import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "step", "progress", "progressBar", "form", "backBtn",
    "operatingMode", "riskPosture", "focus", "concentration", "currentBias",
    "universeBtn", "universeInputs"
  ]

  connect() {
    this.currentStep = 1
    this.totalSteps = 6
    this.selectedUniverse = []
    this.updateUI()
  }

  selectOption(event) {
    const field = event.currentTarget.dataset.field
    const value = event.currentTarget.dataset.value

    // Store the value
    this[`${field}Target`].value = value

    // Visual feedback
    this.highlightSelected(event.currentTarget)

    // Auto-advance after a brief delay
    setTimeout(() => {
      this.nextStep()
    }, 200)
  }

  selectOptionAndSubmit(event) {
    const field = event.currentTarget.dataset.field
    const value = event.currentTarget.dataset.value

    // Store the value
    this[`${field}Target`].value = value

    // Visual feedback
    this.highlightSelected(event.currentTarget)

    // Submit after a brief delay
    setTimeout(() => {
      this.formTarget.submit()
    }, 300)
  }

  toggleUniverse(event) {
    const value = event.currentTarget.dataset.value
    const index = this.selectedUniverse.indexOf(value)

    if (index > -1) {
      // Remove if already selected
      this.selectedUniverse.splice(index, 1)
      event.currentTarget.classList.remove('border-[var(--color-kova-accent)]', 'bg-[var(--color-kova-accent)]/10')
      event.currentTarget.classList.add('border-white/10')
    } else {
      // Add if not selected
      this.selectedUniverse.push(value)
      event.currentTarget.classList.add('border-[var(--color-kova-accent)]', 'bg-[var(--color-kova-accent)]/10')
      event.currentTarget.classList.remove('border-white/10')
    }

    // Update hidden inputs
    this.updateUniverseInputs()
  }

  updateUniverseInputs() {
    // Clear existing inputs
    this.universeInputsTarget.innerHTML = ''

    // Add hidden input for each selected universe option
    this.selectedUniverse.forEach(value => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'universe[]'
      input.value = value
      this.universeInputsTarget.appendChild(input)
    })
  }

  highlightSelected(button) {
    // Find all sibling buttons and remove highlight
    const siblings = button.parentElement.querySelectorAll('button')
    siblings.forEach(btn => {
      btn.classList.remove('border-[var(--color-kova-accent)]', 'bg-[var(--color-kova-accent)]/10')
      btn.classList.add('border-white/10')
    })

    // Highlight selected
    button.classList.add('border-[var(--color-kova-accent)]', 'bg-[var(--color-kova-accent)]/10')
    button.classList.remove('border-white/10')
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++
      this.updateUI()
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--
      this.updateUI()
    }
  }

  updateUI() {
    // Show/hide steps
    this.stepTargets.forEach(step => {
      const stepNum = parseInt(step.dataset.step)
      step.classList.toggle('hidden', stepNum !== this.currentStep)
    })

    // Update progress
    this.progressTarget.textContent = `${this.currentStep} of ${this.totalSteps}`
    this.progressBarTarget.style.width = `${(this.currentStep / this.totalSteps) * 100}%`

    // Show/hide back button
    this.backBtnTarget.classList.toggle('hidden', this.currentStep === 1)
  }
}

